import Marquee from "react-fast-marquee";

export const EditorialMarquee = ({
  items = ["Save More", "Skip The Line", "Climb The Board", "Own The Night"],
  speed = 30,
}) => {
  return (
    <div
      data-testid="editorial-marquee"
      className="border-y border-ink/10 bg-paper py-10 overflow-hidden"
    >
      <Marquee speed={speed} gradient={false} autoFill>
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display font-black uppercase text-5xl md:text-7xl text-stroke tracking-tighter px-16">
              {item}
            </span>
            <span className="text-brand text-3xl">✳</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
